module.exports = __webpack_public_path__ + "static/img/plex.6e8d41c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/plex.png
// module id = xR9k
// module chunks = 1